import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, MessageCircle, Send } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api } from "../lib/api";

export const KeetaSupWaButton = ({ platform }) => {
  const [open, setOpen] = useState(false);
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { if (open) api.keetaSupWaGet(platform).then(setS).catch(() => setS({ enabled: false, time: "23:00" })); }, [open, platform]);
  const save = async () => {
    setBusy("save");
    try { await api.keetaSupWaPut(platform, { enabled: s.enabled, time: s.time }); toast.success(s.enabled ? `يتفعّل الإرسال يومياً الساعة ${s.time}` : "تم إيقاف الإرسال اليومي"); setOpen(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(""); }
  };
  const now = async () => {
    setBusy("now");
    try {
      const r = await api.keetaSupWaNow(platform);
      if (!r.day) toast.info(r.reason || "لا يوجد تقرير");
      else toast.success(`أُرسل ملخص يوم ${r.day} إلى ${r.sent} مشرف`);
      if (r.skipped?.length) toast.warning(`لم يُرسل: ${r.skipped.join("، ")}`, { duration: 9000 });
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الإرسال"); } finally { setBusy(""); }
  };
  return (
    <>
      <Button size="sm" variant="outline" className="gap-1.5" onClick={() => setOpen(true)} data-testid="ksup-wa-btn"><MessageCircle className="h-4 w-4" /> ملخص واتساب</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent dir="rtl" className="max-w-md font-body" data-testid="ksup-wa-dialog">
          <DialogHeader className="text-right"><DialogTitle className="font-heading">ملخص المشرفين اليومي بالواتساب</DialogTitle>
            <DialogDescription>كل مشرف مربوط بموظف يوصله ملخص فريقه لآخر يوم مرفوع: الطلبات المسلّمة والمتأخرة ونسبة التسليم في الوقت وأقل 5 مناديب.</DialogDescription></DialogHeader>
          {!s ? <Loader2 className="mx-auto h-5 w-5 animate-spin text-slate-400" /> : (
            <div className="space-y-3">
              <label className="flex items-center gap-2 text-sm font-semibold"><input type="checkbox" checked={s.enabled} onChange={(e) => setS({ ...s, enabled: e.target.checked })} data-testid="ksup-wa-enabled" /> إرسال يومي تلقائي</label>
              <div className="flex items-center gap-2 text-sm">وقت الإرسال<Input type="time" value={s.time} onChange={(e) => setS({ ...s, time: e.target.value })} className="h-9 w-32" data-testid="ksup-wa-time" /></div>
              {s.last_sent_day && <p className="text-xs text-slate-500" data-testid="ksup-wa-last">آخر ملخص أُرسل: يوم {s.last_sent_day}</p>}
              <div className="flex justify-between gap-2 pt-2">
                <Button variant="outline" size="sm" onClick={now} disabled={!!busy} className="gap-1" data-testid="ksup-wa-now">{busy === "now" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} أرسل الآن</Button>
                <Button size="sm" onClick={save} disabled={!!busy} data-testid="ksup-wa-save">{busy === "save" ? <Loader2 className="h-4 w-4 animate-spin" /> : "حفظ"}</Button>
              </div>
            </div>)}
        </DialogContent>
      </Dialog>
    </>
  );
};
